import { useLoaderData } from 'react-router';
import { useSearchParams } from '../../common/hooks/useSearchParams';
import { useAuth } from '../../public/site/AuthProvider';
import { OrderConfirmationList } from '../OrderConfirmationList/OrderConfirmationList';
import type { CustomerOrdersResponse } from '../../generated/api/customerOrdersResponse';
import type { DefaultListSearchParams } from '../Table';

export const OrderConfirmations = () => {
  const { authenticatedUser } = useAuth();
  const { searchResults: customerOrders, total } = useLoaderData() as CustomerOrdersResponse;
  const { search } = useSearchParams<DefaultListSearchParams>();

  return (
    <div className="of-message-center-content">
      <OrderConfirmationList
        customerOrders={customerOrders}
        totalItems={total}
        searchQuery={search}
        authenticatedUser={authenticatedUser}
      />
    </div>
  );
};
